// removed by extract-text-webpack-plugin
module.exports = {"Header":"_2jDN1","Slider":"_37sWt","SliderControls":"_u9CnC","SliderControl":"_1nWNB","SliderDots":"_2ab3C","SliderDot":"_1XgEO","SliderDotActive":"_3Zu0Y","Overlay":"_1Gi6F"};


//////////////////
// WEBPACK FOOTER
// ./src/components/HotelDetail/HotelHeader/HotelHeader.scss
// module id = 930
// module chunks = 0